export const isLoggedSelector = (state) => state.bailiffAuthReducer.isLogged;
export const uidSelector = (state) => state.bailiffAuthReducer.uid;
export const permissionsSelector = (state) =>
  state.bailiffAuthReducer.permissions;
//
export const registerSelector = (state) => state.bailiffAuthReducer.register;
export const registerStepSelector = (state) => state.bailiffAuthReducer.step;
export const registerLastMailSelector = (state) =>
  state.bailiffAuthReducer.lastMail;
